export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth.token',
  AUTH_USER: 'auth.user',
  AUTH_USER_ROLE: 'auth.user.role',
  AUTHENTICATED: 'auth.authenticated',
  APP_THEME: 'app.theme',
} as const;

